import axios from "axios";

export const cloudinaryService = {
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
    formData.append("folder", "splendrofiy/products");

    console.log(import.meta.env);
    console.log("Cloud:", import.meta.env.VITE_CLOUDINARY_CLOUD_NAME);
    console.log("Preset:", import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET);
    try {
      const response = await axios.post(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
      return response.data.secure_url;
    } catch (error) {
      console.error("Cloudinary error:", error);
      throw error;
    }
  },

  uploadMultiple: async (files, onProgress) => {
    const urls = [];

    for (let i = 0; i < files.length; i++) {
      try {
        const url = await cloudinaryService.uploadImage(files[i]);
        urls.push(url);
        onProgress && onProgress(((i + 1) / files.length) * 100);
      } catch (error) {
        console.error(`Error uploading file ${i}:`, error);
      }
    }

    return urls;
  },

  // Récupérer image optimisée
  getOptimizedUrl: (publicId, width = 500, height = 500) => {
    return `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload/w_${width},h_${height},c_fill,q_auto,f_auto/${publicId}`;
  }
};